import { useAtomValue } from 'jotai';
import { featureFlagsAtom } from 'lib-knowledge-utils/stores/featureFlags';
import { useHasAccess } from 'lib-shared-access-control';

/**
 * Whether the Article suggestions section is available — the review queue and
 * the AI suggestions settings, their nav entries and routes. Needs
 * `settings.knowledge:w`, which the backend asks for to read the AI settings.
 *
 * Shares the multi-conversation draft flag with the AI-provenance UI (see
 * `useShowAiProvenance`): that flow is what fills the review queue, so with the
 * flag off the section would only ever be empty.
 */
export function useShowArticleSuggestions(): boolean {
  const hasSettingsWriteAccess = useHasAccess('settings.knowledge:w');
  const { featureFlags } = useAtomValue(featureFlagsAtom);

  return (
    hasSettingsWriteAccess && featureFlags.smartArticleCreateMultiConversation
  );
}
